import { jsx as o, jsxs as j } from "react/jsx-runtime";
import { createContext as T, forwardRef as h, useMemo as W, useCallback as B, useContext as f } from "react";
import { twMerge as v } from "tailwind-merge";
const k = T({
  value: 0,
  min: 0,
  max: 100,
  size: "md",
  type: "line",
  variant: "info",
  /* v8 ignore next */
  formatLabel: (a) => `${a}%`
}), g = T({
  size: 0,
  center: 0,
  strokeWidth: 0,
  radius: 0,
  circumference: 0,
  arc: 0,
  offset: 0
}), D = h((a, i) => {
  const { className: c, children: d, ...t } = a, {
    value: e,
    min: r = 0,
    max: n = 100,
    type: l,
    size: s = "md",
    variant: m = "info",
    formatLabel: M = (y) => `${y}%`,
    "aria-label": u
  } = t;
  (e < r || e > n) && console.warn("Meter error: ", "Provided `value` is not in range between `min` and `max`.");
  const x = W(
    () => ({
      value: e,
      min: r,
      max: n,
      type: l,
      size: s,
      variant: m,
      formatLabel: M
    }),
    [e, r, n, l, s, m, M]
  ), p = B(() => l === "line" ? /* @__PURE__ */ o(N, { children: /* @__PURE__ */ o(w, {}) }) : /* @__PURE__ */ j(z, { children: [
    /* @__PURE__ */ o(L, {}),
    /* @__PURE__ */ o($, {}),
    /* @__PURE__ */ o(S, {})
  ] }), [l]);
  return /* @__PURE__ */ o(k.Provider, { value: x, children: /* @__PURE__ */ o(
    "div",
    {
      ref: i,
      role: "meter",
      "aria-valuenow": e,
      "aria-valuemin": r,
      "aria-valuemax": n,
      "aria-label": u,
      className: v("", c),
      children: d || /* @__PURE__ */ o(p, {})
    }
  ) });
});
D.displayName = "MeterRoot";
const N = h(
  (a, i) => {
    const { size: c, style: d, className: t = "", ...e } = a, { value: r, max: n, size: l } = f(k), s = c ?? l, m = {
      "--meter-line-indicator-translateX": `-${100 - Math.round(r / n * 100)}%`,
      ...d
    };
    return /* @__PURE__ */ o(
      "div",
      {
        ref: i,
        className: v(
          "relative w-full overflow-hidden rounded-full bg-gray-100",
          s === "sm" && "h-1",
          s === "md" && "h-2",
          s === "lg" && "h-3",
          t
        ),
        style: m,
        ...e
      }
    );
  }
);
N.displayName = "MeterLineTrack";
const w = h(
  (a, i) => {
    const { className: c = "", style: d, ...t } = a, { variant: e } = f(k);
    return /* @__PURE__ */ o(
      "div",
      {
        ref: i,
        className: v(
          "h-full w-full rounded-full transition-transform",
          e === "info" && "bg-blue-400",
          e === "success" && "bg-green-500",
          e === "warning" && "bg-orange-500",
          e === "error" && "bg-red-500",
          c
        ),
        style: {
          transform: "translateX(var(--meter-line-indicator-translateX))",
          ...d
        },
        ...t
      }
    );
  }
);
w.displayName = "MeterLineIndicator";
const z = h(
  (a, i) => {
    const { className: c = "", children: d, size: t, strokeWidth: e } = a;
    let { value: r, min: n, max: l, size: s } = f(k);
    r = Math.min(r, l), r = Math.max(r, n);
    const { width: m, stroke: M } = P(s), u = t ?? m, x = e ?? M, p = u / 2, y = p - x, b = 2 * y * Math.PI, R = (r - n) / (l - n), C = b * (270 / 360), I = b - R * C, X = W(
      () => ({
        size: u,
        center: p,
        strokeWidth: x,
        radius: y,
        circumference: b,
        offset: I,
        arc: C
      }),
      [u, p, x, y, b, I, C]
    );
    return /* @__PURE__ */ o(g.Provider, { value: X, children: /* @__PURE__ */ o(
      "svg",
      {
        ref: i,
        width: u,
        height: u,
        viewBox: `0 0 ${u} ${u}`,
        fill: "none",
        role: "presentation",
        className: c,
        style: { strokeWidth: `${x}px` },
        children: d
      }
    ) });
  }
);
z.displayName = "MeterCircularContainer";
const L = h(
  (a, i) => {
    const { className: c = "", ...d } = a, { center: t, radius: e, arc: r, circumference: n } = f(g);
    return /* @__PURE__ */ o(
      "circle",
      {
        ref: i,
        cx: t,
        cy: t,
        r: e,
        className: v("stroke-gray-100", c),
        strokeDasharray: `${r} ${n}`,
        strokeLinecap: "round",
        transform: `rotate(135 ${t} ${t})`,
        ...d
      }
    );
  }
);
L.displayName = "MeterCircularTrack";
const $ = h(
  (a, i) => {
    const { className: c = "", style: d, ...t } = a, { center: e, radius: r, circumference: n, offset: l } = f(g), { variant: s } = f(k);
    return /* @__PURE__ */ o(
      "circle",
      {
        ref: i,
        cx: e,
        cy: e,
        r,
        strokeDasharray: n,
        strokeDashoffset: l,
        strokeLinecap: "round",
        className: v(
          "transition-all duration-500 ease-in-out",
          s === "info" && "stroke-blue-400",
          s === "success" && "stroke-green-500",
          s === "warning" && "stroke-orange-500",
          s === "error" && "stroke-red-500",
          c
        ),
        transform: `rotate(135 ${e} ${e})`,
        ...t
      }
    );
  }
);
$.displayName = "MeterCircularIndicator";
const S = h(
  (a, i) => {
    const { className: c = "", style: d, formatLabel: t, ...e } = a, { center: r } = f(g), { value: n, size: l, formatLabel: s } = f(k), { label: m } = P(l);
    return /* @__PURE__ */ o(
      "text",
      {
        ref: i,
        x: r,
        y: r,
        className: v("relative z-10 bg-white fill-gray-700", m, c),
        textAnchor: "middle",
        dominantBaseline: "middle",
        ...e,
        children: (t == null ? void 0 : t(n)) || s(n)
      }
    );
  }
);
S.displayName = "MeterCircularLabel";
function P(a) {
  switch (a) {
    case "sm":
      return {
        width: 60,
        stroke: 4,
        label: "text-md"
      };
    case "lg":
      return {
        width: 140,
        stroke: 10,
        label: "text-2xl"
      };
    case "md":
    default:
      return {
        width: 100,
        stroke: 8,
        label: "text-xl"
      };
  }
}
const F = D, E = F, G = N, H = w, J = z, K = L, O = $, Q = S;
export {
  J as CircularContainer,
  O as CircularIndicator,
  Q as CircularLabel,
  K as CircularTrack,
  H as LineIndicator,
  G as LineTrack,
  F as Meter,
  z as MeterCircularContainer,
  $ as MeterCircularIndicator,
  S as MeterCircularLabel,
  L as MeterCircularTrack,
  w as MeterLineIndicator,
  N as MeterLineTrack,
  D as MeterRoot,
  E as Root
};
